import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BookingLoadingPage.module.scss';

interface Props {
  className?: string;
}

const BookingLoadingPage = ({ className, intl }: Props & InjectedIntlProps) => {
  const classes = classNames(css.BookingLoadingPage, className);

  return (
    <div className={classes}>
      {intl.formatMessage({
        id: 'books.bookingLoadingPage.text',
      })}
      <span className={css.BookingLoadingPage__Gif} />
    </div>
  );
};

export default injectIntl(BookingLoadingPage);
